export default __webpack_public_path__ + "static/media/homepage2.bf583795.png";